import { render, staticRenderFns } from "./TicketsStats.vue?vue&type=template&id=f47b6ef2"
import script from "./TicketsStats.vue?vue&type=script&lang=js"
export * from "./TicketsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports